import { Component, Vue } from 'vue-property-decorator';
import WithRender from './stockorderaccess.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      if (!value)
        return '';
      return moment(value).format('YYYY-MM-DD')
    }
  },
  components: {
    Loading
  }
})
export default class StockOrderAccess extends Vue {
  isLoading = false;
  search = '';

  perPage = 200;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  batchSize = 50;

  rules: any = null;
  items = [];
  fields = [
    {
      key: "fullName",
      label: "Merchant",
      sortable: true
    },
    {
      key: "agentCode",
      label: "Agent Code",
      sortable: true,
    },
    {
      key: "whatsApp",
      label: "WhatsApp",
      sortable: true,
    },
    {
      key: "stateOrProvince",
      label: "Province",
      sortable: true,
    },
    {
      key: "accessReason",
      label: "Access Reason",
      sortable: false,
    },
    {
      key: "createdOn",
      label: "Signed Up",
      sortable: true,
    }
  ]

  mounted() {
    this.getRules();
    this.getMerchants();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getMerchants()
  }

  get numbers(): string[] {
    return Array.from(new Set(
      this.items
        .map((m: any) => m.whatsApp)
        .filter((whatsApp: string) => !!whatsApp)
    ));
  }

  get batches(): string[][] {
    const size = this.batchSize > 0 ? this.batchSize : this.numbers.length;
    const batches: string[][] = [];
    for (let i = 0; i < this.numbers.length; i += size)
      batches.push(this.numbers.slice(i, i + size));
    return batches;
  }

  sendBatch(batch: string[]): void {
    this.$router.push({ path: '/customersms', query: { receivers: batch.join(',') } });
  }

  getRules(): void {
    _axios.get(`${config.gateway}admin/internal/report/StockOrderAccess/Rules`)
      .then(response => {
        this.rules = response.data;
      })
      .catch(err => {
        console.error(err);
      });
  }

  getMerchants(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/StockOrderAccess?currentPage=${this.currentPage}
      &pageSize=${this.perPage}
      &search=${encodeURIComponent(this.search)}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not load stock order access list: ${status} ${detail}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
